import { useCallback } from 'react';
import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';

export const useSetLookBackPeriod = () => {
  const { dispatch } = useCampaignEditorContext();
  return useCallback(
    (lookBackPeriodInMinutes: number) =>
      dispatch({
        type: 'SET_LOOKBACK_PERIOD',
        payload: { lookBackPeriodInMinutes },
      }),
    [dispatch],
  );
};
